<template>
  <div>
    <div class="acount-profile-wrap savd-report-profile mb-2 mb-lg-4">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <b-button
            type="button"
            class="arrow-left-btn mr-2"
            @click="goBack"
          >
            <i class="fas fa-chevron-left"></i>
          </b-button>
          <h5 class="saved-reports-title">Back</h5>
        </div>
        
        <h4 class="saved-reports-title">Saved Reports</h4>
        <!-- <a
          class="d-flex align-items-center"
          href="https://business.spendid.io/dashboard"
        >
          <p class="profile_name mb-0 mr-2">{{ userName }}</p>
          <div class="profile_icon">
            <img
              :src="`https://business.spendid.io/api/get-image/${userId}?ver=${Math.random()}`"
            />
          </div>
        </a> -->
        <!-- <div class="acount-profile-wrap ml-2">
          <b-dropdown
            variant="link"
            toggle-class="text-decoration-none p-0"
            no-caret
            right
          >
            <template #button-content>
              <div
                class="d-flex align-items-center"
                href="https://biz.spendid.io/analytics"
              >
                <p class="profile_name mb-0 mr-2">{{ userName }}</p>
                <div class="profile_icon flex-shrink-0">
                  <img
                    class="img-fluid"
                    :src="`https://biz.spendid.io/api/get-image/${userId}?ver=${Math.random()}`"
                  />
                </div>
              </div>
            </template>
            <b-dropdown-item href="#" @click="menuClick('account')">
              <i class="fas fa-user mr-2" aria-hidden="true"></i>
              <span class="d-inline-block">My Account</span>
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item href="#" @click="logoutAll()">
              <i class="fas fa-sign-out-alt mr-2" aria-hidden="true"></i>
              <span class="d-inline-block">Logout</span>
            </b-dropdown-item>
          </b-dropdown>
        </div> -->
      </div>
    </div>
    <b-card
      no-header
      no-body
      class="no-box-shadow assesment-reports-card mb-3 border-radius-10"
    >
      <div class="assesment-reports-card-body">
        <b-table
          bordered
          striped
          :items="items"
          :fields="fields"
          small
          rounded-2
          responsive="sm"
        >
          <template #cell(date)="row">
            {{ dateFormat(row.item.date) }}
          </template>
          <template #cell(spendidScore)="row">
            {{ parseFloat(row.item.spendidScore).toFixed(1) }}
          </template>
          <template #cell(predictedSavingAbility)="row" title="Download report">
            ${{
              (
                reverseFormatNumber(row.item.predictedSavingAbility, "en") / 12
              ).toFixed(0)
            }}
          </template>
          <template #cell(Action)="row" title="Download report">
            <b-button
              size="sm"
              variant="primary"
              class="m-1"
              :href="`https://admin.spendid.io/preview/${row.item.downloadReport}?mybudgetreport=true`"
              target="_blank"
              >Download</b-button
            >
            <!-- <a
              :href="`https://admin.spendid.io/download-request-detail-from-app/${row.item.downloadReport}`"
              download
            >
              <b-button size="sm" variant="primary"> Download </b-button>
            </a> -->
            <!--<b-button
              size="sm"
              variant="dark"
              class="m-1"
              :href="`https://admin.spendid.io/preview/${row.item.downloadReport}?gradBudget=true`"
              target="_blank"
              >Preview</b-button
            > -->
            <!-- <a
              :href="`https://admin.spendid.io/preview/${row.item.downloadReport}?preview=true`"
              target="_blank"
            >
              <b-button size="sm" variant="dark" class="ml-2">
                Preview
              </b-button>
            </a> -->
            <b-button
              size="sm"
              variant="success"
              @click="resumeReport(row.item.downloadReport)"
              class="m-1"
            >
              Resume
            </b-button>
            <b-button
              @click="emailDownloadWithCss(row.item.downloadReport)"
              size="sm"
              class="btn-orange m-1"
            >
              Send To
            </b-button>
            <b-button
              size="sm"
              variant="danger"
              @click="onDelete(row.item.reportId)"
              class="m-1"
            >
              Delete
            </b-button>
          </template>
        </b-table>
      </div>
    </b-card>
    <b-modal
      ref="email-popup-pdf"
      hide-header
      hide-footer
      id="emailpopuppdf"
      header-text-variant="light"
      header-border-variant="none"
    >
      <b-row>
        <b-col>
          <b-col class="text-center">
            <img
              alt="logo"
              height="120"
              style="max-height: 120px"
              src="imgs/logo-mini.png"
            />
            <h4 class="mt-4 mb-3">Email of PDF</h4>
          </b-col>

          <b-form-group class="has-icons-right text-center">
            <!-- <label>Enter your email address.</label> -->
            <b-col class="d-flex align-items-center">
              <b-form-input
                size="lg"
                placeholder="Enter Email"
                v-model="user_email_pdf"
                debounce="300"
                type="text"
                autocomplete="on"
                class="position-relative pr-30"
              >
              </b-form-input>
              <span class="check icon is-small newspace is-right pr-4">
                <i
                  v-if="!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user_email_pdf)"
                  class="fas fa-times text-danger"
                ></i>
                <i v-else class="fas fa-check text-green"></i>
              </span>
            </b-col>
          </b-form-group>

          <b-form-group class="text-center mt-2">
            <b-col class="d-flex align-items-center">
              <b-button
                size="lg"
                class="btn-green w-100"
                @click="sendReport()"
                :disabled="!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user_email_pdf)"
                aria-controls="cust-core-expense-1"
              >
                Send Now
              </b-button>
            </b-col>
          </b-form-group>
          <b-form-group class="text-center mt-2">
            <b-row>
              <b-col>
                <div class="text-center text-secondary small">
                  (Popups must be enabled in device settings)
                </div>
              </b-col>
            </b-row>
          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import moment from "moment-timezone";
import { new_api } from "../../auth_config.json";
export default {
  components: {},
  mounted() {
    let headers = {
      Authorization:
        "Bearer " + this.$cookies.get("userDetail").data.access_token,
    };
    this.$http.get(`${new_api}/get-spendid-score`, { headers }).then((res) => {
      this.items = res.data.data;
    });
  },
  computed: {
    userName() {
      return (
        (this.$cookies.get("userDetail") && this.$cookies.get("userDetail").data
          ? this.$cookies.get("userDetail").data.name
          : null) || this.data
      );
    },
    userId() {
      return (
        (this.$cookies.get("userDetail") && this.$cookies.get("userDetail").data
          ? this.$cookies.get("userDetail").data.id
          : null) || this.data
      );
    },
  },
  data() {
    return {
      fields: [
        {
          key: "date",
          label: "Date/Time Saved",
        },
        {
          key: "spendidScore",
          label: "SPENDID Score",
        },
        {
          key: "predictedSavingAbility",
          label: "Predicted Saving Ability (Monthly)",
        },
        {
          key: "Action",
          label: "Action",
        },
      ],
      user_email_pdf: "",
      activatedId: null,
      // fields: ['date','reportName', 'spendidScore','predictedSavingAbility','downloadReport'],
      items: [],
    };
  },
  methods: {
    goBack(){
      if(document.referrer.includes('biz.spendid')){
        window.history.back()
      }else{
        this.$bvModal.hide('modal-fullscreen')
      }
    },
    sendReport() {
      const previewUrl = `https://admin.spendid.io/preview/${this.activatedId}?email=${this.user_email_pdf}`;
      window.open(previewUrl, "_blank");
      this.$refs["email-popup-pdf"].hide();
    },
    menuClick(param) {
      var reportNotSaved = window.localStorage.getItem("saveReport");
      switch (param) {
        case "account":
          if (reportNotSaved === "no" && !this.stepEnable && this.showResult) {
            var result = confirm(this.msg);
            if (result) {
              setTimeout(() => {
                this.$parent.saveReport();
              }, 1000);
            }
          }
          window.location.replace("https://biz.spendid.io/user/account");
          break;
        default:
          break;
      }
    },
    logoutAll() {
      this.$cookies.remove("userDetail");
      localStorage.removeItem("access_token");
      localStorage.removeItem("storedData");
      this.$cookies.remove("assessmentId");
      window.location.href = "https://spendid.io";
      // this.$parent.resetDefault(false)
    },
    emailDownloadWithCss(param) {
      this.activatedId = param;
      this.$refs["email-popup-pdf"].show();
    },
    resumeReport(row) {
      let headers = {
        Authorization:
          "Bearer " + this.$cookies.get("userDetail").data.access_token,
      };
      this.$http
        .get(`${new_api}/get-report-data/${row}`, { headers })
        .then((res) => {
          // this.$parent.$parent.$parent.fillAutoData(res)
          this.$emit("autoFill", res);
          // _this.$parent.$parent.openSpendidApp()
        });
    },
    reverseFormatNumber(val, locale) {
      var group = new Intl.NumberFormat(locale).format(1111).replace(/1/g, "");
      var decimal = new Intl.NumberFormat(locale).format(1.1).replace(/1/g, "");
      var reversedVal = val.replace(new RegExp("\\" + group, "g"), "");
      reversedVal = reversedVal.replace(new RegExp("\\" + decimal, "g"), ".");
      return Number.isNaN(reversedVal) ? 0 : reversedVal;
    },
    dateFormat(value) {
      if (value) {
        return moment.utc(String(value)).local().format("YYYY-MM-DD hh:mm A");
      }
    },
    onDelete(id) {
      var result = confirm("Are you sure you want to delete this report?");
      if (result) {
        let headers = {
          Authorization:
            "Bearer " + this.$cookies.get("userDetail").data.access_token,
        };
        this.$http
          .delete(`${new_api}/delete-report/${id}`, { headers })
          .then((res) => {
            // this.items= this.items.filter(item=> item.reportId!=id);
            let headers = {
              Authorization:
                "Bearer " + this.$cookies.get("userDetail").data.access_token,
            };
            this.$http
              .get(`${new_api}/get-spendid-score`, { headers })
              .then((res) => {
                this.items = res.data.data;
              });
          });
      }
    },
  },
};
</script>

<style scoped></style>
